import { Exit, Player } from "../objects";
import levelGoalKit from "./levelGoalKit";

class Level7 extends levelGoalKit {
  constructor() {
    super();
    this.name = "The dangerous chambers";
    this.diamondsGoal = 12;
  }

  get id() {
    return this.constructor.key;
  }

  async onInteractWith(el) {
    super.onInteractWith(el);

    // earthquake triggers
    if (el !== this.goalCheckPoint && !el.isClass(Exit)) {
      this.player.disconnect();
      await this.playEarthquake(
        {
          x1: el.position.x - 3,
          x2: el.position.x + 5,
          y1: el.position.y - 10,
          y2: el.position.y,
        },
        2
      );
      this.player.reconnect();
    }
    if (el.isClass(Exit)) {
      this.onComplete();
    }
  }

  onAddElement(el) {
    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
    }
  }
}

Level7.key = "level_7";
export default Level7;
